<template>
  <div class="card shadow" >
    <div class="card-header border-0" >
      
      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0">
            Payment Types
          </h3>
        </div>
        <div class="col-md-9 text-right">
           <div v-if="checkedItems.length == 0">
            <base-button v-if="accountId > 0" class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add Payment Type</base-button>
           </div>
  
          <div v-else>
            <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status','A')">Activate</base-button>
            <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status','I')">Deactivate</base-button> 
            <div class="ml-1"></div>
          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="520" placement="right" @close="onClose" :visible="drawerVisible">
         <!-- v-if="currentProfile=='payment_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode" -->
          <payment-type-form :accountId="accountId" @refreshPage="refreshPage" :key="componentKey"></payment-type-form>
    </a-drawer>



    <div class="table-responsive">
      <!-- <vuetable v-if="accountId != null" ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data" no-data-template="Empty"
        @vuetable:pagination-data="onPaginationData" @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError" > -->
        <vuetable v-if="accountId != null" ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
          :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data" no-data-template="Empty"
          @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError" 
          @vuetable:pagination-data="onPaginationData">
            <template slot="actions" slot-scope="props">
                <center>
                <div class="table-button-container">
                    <button class="btn btn-warning btn-sm" @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                    <button class="btn btn-danger btn-sm" @click.prevent="deleteRow(props.rowData.id)">Delete</button>
                </div>
                </center>
            </template>

      </vuetable>
      <div v-else class="col-md-12">
        <center>
          <h5 class="navbar-heading text-muted">Please select an account for viewing.</h5>
        </center>
        <br/>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>


<script>
  import PaymentTypeForm from '../POS Profiles/PaymentTypeForm.vue';
  import TerminalForm from '../POS Profiles/TerminalForm2.vue';
  import LicenseForm from '../POS Profiles/License/LicenseForm2.vue';
  import AccountForm from '../POS Profiles/License/AccountForm.vue';
  import axios from "axios";
  import {
    mapState,
    mapActions
  } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  var component_x;

  export default {
    name: 'licenses-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
      Vuetable,
      VuetablePagination,
      TerminalForm,
      LicenseForm, 
      AccountForm,
      PaymentTypeForm
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
    },
    data() {
      return {
        accountId: null,
        filterStatus: "",
        profileAction: "",
        checkedFields: [],
        checkedItems: [],
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        drawerVisible: false,
        visible: false,
        apiURL: "",
        fields: ['__checkbox', "id", "name", '__slot:actions'],
        // fields: ["id", "name", '__slot:actions'],
        sortOrder: [{
          field: "name",
          direction: "asc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        }
      }
    },
    watch: {
      currentApiURL: function () {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL 
      },
      parameters: function () {     
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters + "&account_id=" + this.accountId
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
       ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        showDrawer(id){
            // alert("Create Payment Types...")
            this.drawerVisible = true;
            this.updateProfileId(id);
            this.componentKey++;
        },
        onClose(){
            this.drawerVisible = false;
        },
        refreshPage() {
            this.onClose()
            this.$refs.vuetable.refresh()
            this.$message['success'](
                "Operations successfull."
            );
        },
        deleteRow(id) {
          axios({
              method: 'delete',
              url: this.endPoint + this.currentProfile + '/' + id + "?account_id=" + this.accountId,
              headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
              },
            })
            .then(function () {
              component_x.$message['success'](
                "Operations successfull."
              );
              // component_x.successMessage = "Successfully deleted record"
              component_x.$refs.vuetable.refresh()
            })
            .catch(function () {
              alert("Invalid Credentials")
            });
        },
        log() {
          this.checkedItems = this.$refs.vuetable.selectedTo
        },
        async massupdate(field_name, value) {
          var field_update = {}
          field_update[field_name] = value
          var payload = {
            ids: this.checkedItems,
            field_update: field_update
          }
          var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update?account_id=" + this.accountId, null,
            payload)
          if (response["message"] == "Ok") {
            // this.successMessage = "Update successful!"
            this.$message['success'](
                "Operations successfull."
            );
            this.$refs.vuetable.refresh()
            this.checkedItems = []
            this.$refs.vuetable.selectedTo = []
          } else {
            this.$message['error'](
                "Operations failed."
            );
            // this.successMessage = "Update failed!"
          }
        },
        async onLoadError(error) {
          console.log(error)
        },
        onChangePage(page) {
          this.$refs.vuetable.changePage(page);
        },

    },
    mounted: function () {
      console.log(this)
      component_x = this;
      this.accountId = this.$attrs.accountId
      this.updateCurrentProfile("payment_types")
      this.apiURL = this.currentApiURL + "?account_id=" + this.accountId
    }
  }
</script>

<style>
</style>